import { type CoWorkerScheduleActivity } from "@/features/calendar/types";
import { type Schedule } from "@repo/api";
import { translateScheduleShiftType } from "@repo/ui";
import { differenceInMinutes } from "date-fns";

import { sortSchedule } from "./sortSchedules";

export const mapScheduleToActivity = (i: Schedule) => ({
  id: String(i.id),
  appointmentType: "scheduleActivity" as const,
  shiftId: i.shiftId ?? Math.random().toString(),
  emailId: i.coworkerEmail.toLowerCase(),
  allDay: false,
  start: new Date(i.shiftStartTime),
  end: new Date(i.shiftEndTime),
  title: i.activity ?? translateScheduleShiftType(i.shiftType),
  length: differenceInMinutes(i.shiftEndTime, i.shiftStartTime),
  shiftType: i.shiftType,
  activity: i.activity,
  parentType: "schedule" as const,
  subType: i.shiftType?.toLowerCase() ?? i.activity?.toLowerCase() ?? "break",
  editedAt: i.editedAt,
  editedBy: i.editedBy,
});

export const getScheduleActivities = (
  schedules: Schedule[] | undefined,
  emailId: string,
  enableWorkhours?: boolean
): CoWorkerScheduleActivity[] => {
  if (!enableWorkhours || !schedules) {
    return [];
  }

  const breaks = schedules
    .filter((i) => i.coworkerEmail.toLowerCase() === emailId.toLowerCase())
    .sort(sortSchedule);

  if (breaks.length === 0) {
    return [];
  }

  return breaks.map(mapScheduleToActivity);
};
